import store from "store";
import api from "config/api";
import { getUserInfo, storeUserInfo } from "utils/StorageHelper";
import { manageAPICall } from "./CommonCrudAction";
import { userInfoSelector } from "components/_selectors/authSelectors";
import { successMessage, errorMessage } from "utils/ToastNotificationHelper";
import { removeLocalStorage } from "utils/StorageHelper";
import apiService from "services/api.service";

export const loginUser = async (data, callback) => {
  manageAPICall(api.login.url, api.login.method, data, callback);
};
export const forgotPasswordCall = async (data, callback) => {
  manageAPICall(api.forgotPassword.url, api.forgotPassword.method, data, callback);
};
export const verifyOTPAPI = async (data, callback) => {
  // manageAPICall(api.verifyOTP.url, api.verifyOTP.method, data, callback);
  const response = await apiService.submitPublicTokenData(
    api.verifyOTP.url,
    data,
    data.token
  );
  if (response) {
    callback(response.status, response);
  }
};
export const updateProfile = async (data, callback) => {
  manageAPICall(api.updateProfile.url, api.updateProfile.method, data, callback);
};
export const uploadImage = async (data, callback) => {
  const response = await apiService.submitFormData(
    api.uploadImageManager.url,
    data
  );
  if (response) {
    callback(response.status, response);
  }
};
export const changePassword = async (data, callback) => {
  manageAPICall(api.changePassword.url, api.changePassword.method, data, callback);
};
export const getProfileDetails = async (data, callback) => {
  manageAPICall(api.getProfileDetails.url, api.getProfileDetails.method, data, callback);
};
export const resetPasswordAPI = async (data, callback) => {
  const response = await apiService.submitPublicTokenData(
    api.resetPassword.url,
    data,
    data.token
  );
  if (response) {
    callback(response.status, response);
  }
};
export const logoutUser = async (callback) => {
  // var userInfo = userInfoSelector(store.getState());
  // var deviceId = userInfo?.device?.device_id;
  // if (deviceId) {
  //   var data = {
  //     device_id: deviceId,
  //   };
    manageAPICall(api.logout.url, api.logout.method, {}, (status, response) => {
      if (status) {
        successMessage("You have logged out successfully");
        removeLocalStorage("userInfo");
        store.dispatch({
          type: "UPDATE_USER_DETAILS",
          payload: {},
        });
        callback();
      } else {
        errorMessage(response.message);
      }
    })
  // } else {
  //   removeLocalStorage("userInfo");
  //   store.dispatch({
  //     type: "UPDATE_USER_DETAILS",
  //     payload: {},
  //   });
  //   callback();
  // }
};
export const refreshToken = async (callback) => {
  var userInfo = userInfoSelector(store.getState());
  var data = {
    refresh_token: userInfo.refresh_token,
  };
  manageAPICall(api.refreshToken.url, api.refreshToken.method, data, (status, response) => {
    if (response) {
      if (status) {
        var obj = getUserInfo();
        obj.authToken = response.data?.authToken;
        storeUserInfo(obj);
        callback();
      } else {
        console.log("error");
      }
    }
  });
};
export const refreshFirebaseToken = async (data) => {
  // manageAPICall(api.refreshFirebaseToken.url, api.refreshFirebaseToken.method, data, (status, response) => {
  //   if(status){
  //       var obj = getUserInfo();
  //       obj.fcmToken = response.data?.fcmToken;
  //       storeUserInfo(obj);
  //     }else{
  //       console.log("error");
  //     }
  // });
  var obj = getUserInfo();
  obj.fcmToken = data?.fcm_token;
  storeUserInfo(obj);
}

export const resend2FACode = async (data, callback) => {
  manageAPICall(api.resend2FACode.url, api.resend2FACode.method, data, callback);
};
export const verify2FACode = async (data, callback) => {
  manageAPICall(api.verify2FACode.url, api.verify2FACode.method, data, callback);
};
